import "./RunRoute.css"
import React from "react"
import { RunModelList } from "./components/RunModelList"
import { RunModelDto, useGetModelsQuery } from "@store/services/modelsService"
import { Box, CircularProgress, Typography } from "@mui/material"

export default function RunRoute() {
  const { data: runModels, isFetching } = useGetModelsQuery()
  const [selectedModel, setSelectedModel] = React.useState<RunModelDto | undefined>(undefined)

  const modelList = isFetching ? (
    <CircularProgress />
  ) : (
    <RunModelList runModels={runModels || { items: [] }} />
  )

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h4" sx={{ mb: 4 }}>
        Models
      </Typography>
      {modelList}
    </Box>
  )
}
